var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_12380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0ZM13.593 6.468C13.593 6.07018 13.435 5.68864 13.1537 5.40734C12.8724 5.12604 12.4908 4.968 12.093 4.968C11.6952 4.968 11.3136 5.12604 11.0323 5.40734C10.751 5.68864 10.593 6.07018 10.593 6.468V10.593H6.468C6.07018 10.593 5.68864 10.751 5.40734 11.0323C5.12604 11.3136 4.968 11.6952 4.968 12.093C4.968 12.4908 5.12604 12.8724 5.40734 13.1537C5.68864 13.435 6.07018 13.593 6.468 13.593H10.593V17.718C10.593 18.1158 10.751 18.4974 11.0323 18.7787C11.3136 19.06 11.6952 19.218 12.093 19.218C12.4908 19.218 12.8724 19.06 13.1537 18.7787C13.435 18.4974 13.593 18.1158 13.593 17.718V13.593H17.718C18.1158 13.593 18.4974 13.435 18.7787 13.1537C19.06 12.8724 19.218 12.4908 19.218 12.093C19.218 11.6952 19.06 11.3136 18.7787 11.0323C18.4974 10.751 18.1158 10.593 17.718 10.593H13.593V6.468Z",
    fill: "#11B50C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_12380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBuilding);
export default __webpack_public_path__ + "static/media/add-building.d8330d43167a268203e6b0d3b3d1bbf1.svg";
export { ForwardRef as ReactComponent };